import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Truck, LogOut, Home } from "lucide-react";

export default function DashboardShell({ title, subtitle, children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = async () => { await logout(); navigate("/"); };
  return (
    <div className="min-h-screen bg-ksy-bg">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-5 md:px-8 h-[68px] flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="dash-logo">
            <span className="grid place-items-center w-9 h-9 rounded-lg bg-ksy-navy text-white"><Truck className="w-5 h-5" /></span>
            <span className="font-display font-extrabold text-ksy-navy">KS&amp;Y Transport</span>
          </Link>
          <div className="flex items-center gap-3">
            <Link to="/" className="hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-ksy-navy" data-testid="dash-home"><Home className="w-4 h-4" /> Home</Link>
            <span className="hidden md:block text-sm text-slate-400">{user?.email}</span>
            <button onClick={onLogout} className="inline-flex items-center gap-1.5 text-sm font-bold text-slate-600 hover:text-red-500 border border-slate-200 rounded-lg px-3 py-2" data-testid="dash-logout"><LogOut className="w-4 h-4" /> Logout</button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-5 md:px-8 py-10">
        <h1 className="font-display font-extrabold text-3xl text-ksy-navy">{title}</h1>
        {subtitle && <p className="text-slate-500 mt-1">{subtitle}</p>}
        <div className="mt-8">{children}</div>
      </main>
    </div>
  );
}
